@if (feed === undefined || feed.length > 0) {
  <section class="featured" aria-labelledby="communityFeaturedTitle" aria-roledescription="carousel">
    @if (skipTarget) {
      <a href class="featured__skip" (click)="skipFeatured($event)">Skip featured posts</a>
    }
    <div class="featured__header">
      <h2 class="featured__title" id="communityFeaturedTitle">Featured</h2>
      @if (slides.length > 1) {
        <div class="featured__controls">
          <span class="featured__position" aria-live="polite">{{ current() + 1 }} of {{ slides.length }}</span>
          <button type="button" class="featured__arrow" aria-label="Previous featured post" [attr.aria-disabled]="isFirst()" (click)="goTo(current() - 1)">
            <span class="material-icons" aria-hidden="true">chevron_left</span>
          </button>
          <button type="button" class="featured__arrow" aria-label="Next featured post" [attr.aria-disabled]="isLast()" (click)="goTo(current() + 1)">
            <span class="material-icons" aria-hidden="true">chevron_right</span>
          </button>
        </div>
      }
    </div>

    <div class="featured__list" #list (scroll)="updateCurrent()">
      @if (feed === undefined) {
        <div class="featured__slide" aria-hidden="true">
          <span class="featured__skeleton featured__skeleton--badge"></span>
          <span class="featured__skeleton featured__skeleton--title"></span>
          <span class="featured__skeleton"></span>
          <span class="featured__skeleton featured__skeleton--short"></span>
        </div>
      } @else {
        @for (slide of slides; track slide.item.type + slide.item.id; let i = $index) {
          <div class="featured__slide" role="group" aria-roledescription="slide" [attr.aria-label]="(i + 1) + ' of ' + slides.length" [attr.inert]="i === current() ? null : ''">
            <h3 class="featured__headline">
              @if (route(slide.item); as r) {
                <a class="featured__headline-link" [uiSref]="r.state" [uiParams]="r.params" [innerHTML]="slide.headline | emojiHtml"></a>
              } @else {
                <span [innerHTML]="slide.headline | emojiHtml"></span>
              }
            </h3>
            @if (slide.excerpt) {
              <p class="featured__excerpt">{{ slide.excerpt }}</p>
            }
            <div class="featured__byline">
              @if (glyph(slide.item); as g) {
                <span class="featured__glyph" aria-hidden="true"><span class="material-icons">{{ g }}</span></span>
              } @else if (slide.item.user) {
                <ut-avatar-badges [user]="slide.item.user" aria-hidden="true"></ut-avatar-badges>
              }
              <span class="featured__byline-text">
                <span class="featured__author">{{ authorName(slide.item) }}</span>
                <span class="featured__meta">
                  {{ typeLabel(slide.item) }}
                  @if (slide.item.type !== 'referral_campaign') {
                    <span aria-hidden="true">&middot;</span> {{ slide.item.published_at | relativeDate }}
                  }
                  @if (showStats(slide.item)) {
                    <span class="featured__stat">
                      <span class="material-icons" aria-hidden="true">favorite_border</span>
                      <span class="sr-only">Likes:&ngsp;</span>{{ likeCount(slide.item) | utNumToK }}
                    </span>
                    <span class="featured__stat">
                      <span class="material-icons" aria-hidden="true">chat_bubble_outline</span>
                      <span class="sr-only">Comments:&ngsp;</span>{{ commentCount(slide.item) | utNumToK }}
                    </span>
                  }
                </span>
              </span>
            </div>
          </div>
        }
      }
    </div>

    @if (slides.length > 1) {
      <div class="featured__dots" aria-hidden="true">
        @for (slide of slides; track slide.item.type + slide.item.id; let i = $index) {
          <button type="button" tabindex="-1" class="featured__dot" [class.is-current]="i === current()" (click)="goTo(i)"></button>
        }
      </div>
    }
  </section>
}
